import { Form, Modal, Select } from "antd";
import { FormikHelpers, useFormik } from "formik";
import { useEffect } from "react";
import { folderDeleteValidationScheme } from "../../schemas/formValidationScheme";
import TextArea from "antd/es/input/TextArea";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";

type FileUploadModalProps = {
  close: () => void;
  openState: boolean;
  open: () => void;
};

function StatusUpdateSuccessfullyModal(props: FileUploadModalProps) {
  const updateStatusState = useSelector((state: RootState) => state.engageTranslationState.engageTranslationDetailPageState.updateStatusState);

  const StatusUpdateSuccessfullyModalContentContent = () => {
    const navigate = useNavigate();

    // console.log(errors);
    return (
      <div
        className="d-flex flex-column justify-content-between gap-4 h-100 needs-validation"
        id="createNewFolderForm">
        <h4>Status Updated</h4>
        <div className="d-flex flex-column gap-1">
          {updateStatusState.error ? (
            <div className="d-flex flex-column gap-2">
              <div>
                <p>QC Status updated unsuccessfully, click ok and try again later </p>
                <p className="text-danger">Error: {updateStatusState.errorMessage}</p>
              </div>

              <div className="d-flex gap-4 justify-content-center">
                <button
                  onClick={() => props.close()}
                  className="button">
                  Ok
                </button>
              </div>
            </div>
          ) : (
            <div className="d-flex flex-column gap-2">
              <p>QC Status updated successfully, click ok to return to the QC List screen.</p>

              <div className="d-flex gap-4 justify-content-center">
                <button
                  onClick={() => navigate(-1)}
                  className="button">
                  Ok
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };
  //   const FileUploadModalWidth = "30%";
  return (
    <Modal
      //   width={FileUploadModalWidth}
      centered
      zIndex={10000}
      confirmLoading={updateStatusState.loading}
      footer={[]}
      onCancel={() => props.close()}
      open={props.openState}>
      <StatusUpdateSuccessfullyModalContentContent />
    </Modal>
  );
}

export default StatusUpdateSuccessfullyModal;
